import bulmaCarousel from '../../../node_modules/bulma-carousel/dist/js/bulma-carousel.min.js';

const carousel = {
  initColumnCarousels(){
    // Init column-carousel-slides

    const options = {
      slidesToShow: 3,
      breakpoints: [
        // From 768 and below = show 1 slide
        { changePoint: 768, slidesToShow: 1, slidesToScroll: 1 },
        // From 1024 and below = show 2 slides
        { changePoint: 1024, slidesToShow: 2, slidesToScroll: 1 },
      ],
      pagination: false,
    };
    const carousels = bulmaCarousel.attach('.column-carousel-slides', options);

    // Recalculate slide width considering gap
    carousels.forEach(carousel => {
      const items = carousel.slides;
      const gap = 24; // Default gap in pixels

      const recalculateWidth = () => {
        const wrapperWidth = carousel.wrapperWidth;
        const slidesToShow = window.innerWidth >= 1024 ? 3 : (window.innerWidth >= 768 ? 2 : 1);
        const totalGap = gap * (slidesToShow - 1);
        const slideWidth = (wrapperWidth - totalGap) / slidesToShow;

        // Set gap to the carousel wrapper
        carousel.container.style.gap = slidesToShow > 1 ? `${gap}px` : '0';

        items.forEach(item => {
          item.style.width = `${slideWidth}px`;
        });
      };

      recalculateWidth();
      window.addEventListener('resize', recalculateWidth);
    });


    // Add slide num / slides count updater
    carousels.forEach(bulmaCarousel => {
      const slideCount = bulmaCarousel.state.length - (document.body.scrollWidth >= 1024 ? 2 : (document.body.scrollWidth >= 768 ? 1 : 0));
      const $carouselWrapper = bulmaCarousel.element.closest('.column-carousel');
      const $slideNumCount = $carouselWrapper.querySelector('.column-carousel-slide-nums');

      const $slideNum = $slideNumCount.querySelector('[data-carousel-slide-num]');
      const $slideCount = $slideNumCount.querySelector('[data-carousel-slide-count]');
      $slideNum.textContent = 1;
      $slideCount.textContent = slideCount || 1; // If nothing to slide, show 1 instead of 0

      bulmaCarousel.on('show', (bulmaCarouselInstance) => {
        // Does not have correct values if not delayed :/ Not event if using after:show event
        setTimeout(() => {
          $slideNum.textContent = bulmaCarouselInstance.state.index + 1;
        }, 600);
      });
    });

  },

  initProductCarousels(){
    // Init product-carousel-slides

    const options = {
      slidesToShow: 6,
      breakpoints: [],
      pagination: false,
    };

    const carousels = bulmaCarousel.attach('.product-carousel-slides', options);

    carousels.forEach(bulmaCarousel => {
      const $carouselWrapper = bulmaCarousel.element.closest('.product-carousel');
      const $productImage = $carouselWrapper.querySelector('[data-product-image]');
      const $productImageWrapper = $productImage.parentElement;
      const $slides = bulmaCarousel.element;

      // Wrap slider-container by div with overflow hidden
      // This is because Bulma carousel does not clip the overflowing slides(!)
      // and can't just add overflow hidden to slider parent because navigation buttons are in the same parent
      // so the solution is to add clipping wrapper around slider-container.
      const $sliderContainerWrapper = document.createElement('div');
      $sliderContainerWrapper.classList.add('is-clipped');
      const $sliderContainer = $slides.querySelector('.slider-container');
      $sliderContainer.parentElement.insertBefore($sliderContainerWrapper, $sliderContainer);
      $sliderContainerWrapper.appendChild($sliderContainer);

      // Load event listener for large product image
      $productImage.addEventListener('load', (evt) => {
        $productImageWrapper.classList.remove('-is-loading');
      });

      // Click event listener for thumbnails
      $slides.addEventListener('click', (evt) => {
        const $thumbnail = evt.target.closest('[data-product-image-url]');

        if($thumbnail){
          evt.preventDefault();
          evt.stopPropagation();
          $productImageWrapper.classList.add('-is-loading');
          $productImage.src = $thumbnail.getAttribute('data-product-image-url');

          const $selectedThumbnail = $slides.querySelector('[data-product-image-url].is-selected');
          if($selectedThumbnail){
            $selectedThumbnail.classList.remove('is-selected');
          }
          $thumbnail.classList.add('is-selected');
        }

      });

      // Select first thumbnail
      $slides.querySelector('[data-product-image-url]').classList.add('is-selected');
    });

  },

  init(){
    this.initColumnCarousels();
    this.initProductCarousels();
  }
};

export default carousel;
